module.exports = __webpack_public_path__ + "img/usuario.d40d1d93.png";